<template>
  <b-modal id="modal-text" size="sm" hide-footer hide-header>
    <div class="text-center my-2">
      <img class="mb-4" :src="renderImage()" width="100" />
      <p class="m-0">{{ textModal }}</p>
      <!-- <b-button class="btn" @click="closeModal">ตกลง</b-button> -->
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    textModal: {
      type: String,
      default: "บันทึกสำเร็จ",
    },
    unCheck: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    renderImage() {
      let img = null;

      if (this.unCheck) {
        img = require("@/assets/images/icons/warning.png");
      } else {
        img = require("@/assets/images/icons/icon-check.svg");
      }

      return img;
    },
    closeModal() {
      this.$bvModal.hide("modal-text");
    },
  },
};
</script>

<style scoped>
.btn {
  background: #b41bb4;
  color: white !important;
  border-radius: 8px;
  min-width: 120px;
  border: none;
}
</style>
